.onBoardingModalBody {
  margin: 16px 20px 4px 20px;
  padding-bottom: 30px;

  // style added for react-slick dots
  ul li {
    height: 15px;
    margin: 0 !important;
    width: 15px;
  }

  .onboardingSlideContainer {
    position: relative;
    text-align: center;

    .imageContainer {
      margin: auto;
      height: 222px;
      max-width: 296px;

      .imgShadow {
        border-radius: 4px;
        box-shadow: 12px 8px rgba(0, 0, 0, 0.15);
        height: 222px;
        display: inline-block;
        width: auto;
      }

      .onBoardingImages {
        svg {
          border-radius: 4px;
          height: auto !important;
          max-height: 222px !important;
          max-width: 296px !important;
          width: auto !important;
        }
      }
    }

    .onboardingInfo {
      margin-top: 39px;

      .onboardingTitle {
        color: var(--onboarding-title-color);
        font-family: var(--onboarding-title-font);
        font-size: var(--onboarding-title-size);
        line-height: var(--onboarding-title-line-height);
      }

      .onboardingDescription {
        color: var(--onboarding-description-color);
        font-family: var(--onboarding-description);
        font-size: var(--onboarding-description-size);
        line-height: var(--onboarding-description-line-height);
        margin-top: 12px;
        padding-bottom: 39px;
      }
    }
  }
}

.carouselButton {
  align-items: center;
  border-radius: 4px;
  border: 0;
  display: flex;
  height: 32px;
  justify-content: center;
  position: absolute;
  width: 32px;
  z-index: 1;

  &,
  img {
    cursor: pointer;
  }
}

.carouselButtonClose {
  background-color: #5cc78e;
  right: 0px;
}

.carouselButtonNext {
  background-color: #88929d;
  right: 0px;
}

.carouselButtonBack {
  background-color: #88929d;
  bottom: -32px;
  left: 0px;

  &:disabled,
  &:disabled img {
    background: #ececec;
    cursor: not-allowed;
  }
}

@media screen and (max-width: 500px) {
  .onBoardingModalBody {
    margin: 0 24px;

    .onboardingSlideContainer {
      .imageContainer {
        height: 212px;
        max-width: 90%;

        .imgShadow {
          max-height: 212px;
          height: auto;
        }

        .onBoardingImages {
          svg {
            max-height: 212px !important;
            max-width: 100% !important;
          }
        }
      }

      .onboardingInfo {
        margin-top: 22.5px;

        .onboardingDescription {
          padding-bottom: 22.5px;
        }
      }
    }
    .carouselButtonNext {
      right: 0px;
    }

    .carouselButtonBack {
      left: 0px;
    }
  }
}

@media screen and (max-width: 400px) {
  .onBoardingModalBody {
    .onboardingSlideContainer {
      .imageContainer {
        .imgShadow div {
          position: relative;
          top: 5px;
        }
      }
    }
  }
}
